import React, { useState } from "react";

import '../styles/Image.css';

const Image = ({ src, alt, className, smallLoading=false, ...props }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div style={{ position: "relative", display: "flex", width: "100%", height: "100%", alignItems: "center", justifyContent: "center" }}>
      {loading && (
        <div className={className}>
            <div className={smallLoading ? "image-loading-dots-small" : "image-loading-dots"}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={className}
        onLoad={() => setLoading(false)}
        style={{ display: loading ? "none" : "block" }}
        {...props}
      />
    </div>
  );
};

export default Image;